<template>
<div class="widthFull container-fluid mainBackVaillant pt-5 mt-5">
  <div class="row justify-content-center ">
    <div class="widthFull container vaillantCont pt-5 mt-5">
      <div class="row justify-content-center pb-5 mb-5">
        <div class="col-md-12  center">
          <img class="img-fluid payImage" src="../../assets/images/success.png">
        </div>

        <div class="col-md-6  center">

          <h1 class="h2 center Regular Bold  "><b>Pratica {{practice}}</b></h1>

          <h4 class="center"><b>Grazie per averci scelto, </b></h4>
          <h3 class="center "><b>il tuo pagamento è avvenuto con successo</b></h3>

        </div>
        <div class="col-md-12 mt-5 center">
        <router-link class="btn btn-secondary btn-lg" to="/pratiche"> Gestione Pratiche </router-link>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import {
  mapState,
  mapGetters
} from 'vuex'
import axios from 'axios'
import {
  USER_REQUEST,
  USER_SET_DEFAULT_SHIP_DATA
} from 'actions/user'

const moment = require('moment')


export default {
  name: 'paymentError',
  components: {

  },
  data() {
    return {
      loadingState: false,
      userToken: '',
      vw: window.innerWidth,
      practice: '',
    }
  },
  methods: {



  },
  watch: {


  },
  updated: function() {


  },
  created: function() {
    this.$log(this.$route.params.id)
    this.practice = this.$route.params.id
  },
  mounted: function() {


  },
  computed: {
    ...mapGetters(['getProfile', 'isAuthenticated', 'isProfileLoaded']),
    ...mapState({
      profile: state => state.user.profile,
    })
  },


}
</script>

<style lang="scss" scoped>
.errorIcon {
    max-width: 150px;
    margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/paymentSuccess/index.vue